import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { GroupEffects } from './group.effects';
import { groupsReducer } from './group.reducer';

export const provideGroupStore = () => [provideState('groups', groupsReducer), provideEffects([GroupEffects])];
